import { render, staticRenderFns } from "./StudentLicenses.vue?vue&type=template&id=2f674620&scoped=true&"
import script from "./StudentLicenses.vue?vue&type=script&lang=js&"
export * from "./StudentLicenses.vue?vue&type=script&lang=js&"
import style0 from "./StudentLicenses.vue?vue&type=style&index=0&id=2f674620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f674620",
  null
  
)

export default component.exports